.wrapper {
  :global(.ant-tooltip) {
    white-space: pre-wrap;
  }
}
